import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#44403C",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.3",
      d: "M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#44403C",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.3",
      d: "M10 1.667a12.083 12.083 0 0 0 0 16.666 12.083 12.083 0 0 0 0-16.666M1.667 10h16.666"
    }, null, -1)
  ]))]))
}
export default { render: render }